<template>
    <div class="result-filter facet-filter facet-languages">
        <h5 class="filter-title ">
            <div class="btn toggle-xs" data-toggle="collapse-next">
                {{$t("service_download.filter_sorting.facet_filter_lang")}}<i class="icon icon-toggle-state"></i></div>
        </h5>
        <div class="scroll-content collapse" v-bar>
            <ul class="list-unstyled">
                <li v-bind:key="index" v-for="(option,index) in options">
                    <facet-checkbox-item :option="option" @change="updateSelection($event)"></facet-checkbox-item>
                </li>
            </ul>

        </div>
        <button @click="resetSelection()" class="btn btn-action action-remove-filter" v-show="showRemoveAction">
            {{$t("service_download.filter_sorting.filter_remove")}}
        </button>
    </div>
</template>

<script>

    import vSelect from 'vue-select'
    import FacetCheckboxItem from "@/components/facet/FacetCheckboxItem";

    import mixin from '../FacetMixin';

    export default {
        name: "FilterFacetLang",
        mixins: [mixin],
        components: {
            vSelect, FacetCheckboxItem
        },
        props: ['value', 'facet', 'facetId', 'selection'],
        data: function () {
            return {
                update: true,
                options: null
            }
        },
        methods: {
            getOptionName(id) {
                return id.toUpperCase();
            },
            filterOptions(option) {
                return option.toLowerCase() !== 'nn';
            }
        }
    }
</script>

<style src="vue-select/dist/vue-select.css"></style>

<style lang="less">
    .facet-filter {
        .btn-action {
            padding: 3px 0px;
            font-size: 13px;
            color: #0EA4DF;
        }
    }

</style>
